module.exports = __webpack_public_path__ + "static/media/avoid-stress-first-lithonia-medical.8a762ec7.jpg";